export const getAPIAccessToken = async (getAccessTokenSilently, getAccessTokenWithPopup, options) => {
    try {
        return await getAccessTokenSilently({ ...options });
    }
    catch (e) {
        if (Object.prototype.hasOwnProperty.call(e, 'error') && e.error === 'consent_required') {
            return getAccessTokenWithPopup({ ...options });
        }
        throw e;
    }
};
//# sourceMappingURL=auth0.js.map